import {
  LayoutContent,
  LayoutFooter,
  LayoutHeader,
  LayoutMain,
  LayoutWrapper,
} from "components/utils/layout.styles";
import { StyledHeader, StyledParagraph } from "components/utils/text";
import React from "react";
import { Outlet, useNavigate } from "react-router";
import { Loading } from "components/utils/loading";
import { usePlatformContext } from "config/context";
import { StyledIconButton } from "./utils/buttons";
import { CiLogout } from "react-icons/ci";

function Layout() {
  const navigate = useNavigate();
  const context = usePlatformContext();
  return (
    <LayoutWrapper>
      <LayoutMain>
        <LayoutHeader>
          <StyledHeader
            cursor={"pointer"}
            onClick={() => {
              context.setLoading(true);
              navigate("/", { replace: false });
            }}
          >
            Bestgrowth
          </StyledHeader>
          <StyledIconButton
            onClick={() => {
              console.log("logout");
              context.api.logout();
            }}
          >
            <CiLogout />
          </StyledIconButton>
        </LayoutHeader>
        <LayoutContent normal={!context.loading}>
          {context.loading ? <Loading /> : <Outlet />}
        </LayoutContent>
        <LayoutFooter>
          <StyledParagraph fontSize={"0.8rem"} color={"#A1A1A1"}>
            This site is protected by reCAPTCHA and the Google Privacy Policy
            and Terms of Service apply.
          </StyledParagraph>
        </LayoutFooter>
      </LayoutMain>
    </LayoutWrapper>
  );
}

export default Layout;
